import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

/**
 * Portal component para renderizar componentes fuera del DOM tree del componente padre
 */
const Portal = ({ children, target = 'portal-root' }) => {
    const [portalElement, setPortalElement] = useState(null);

    useEffect(() => {
        // Buscar el elemento target o crearlo si no existe
        let element = document.getElementById(target);
        
        if (!element) {
            element = document.createElement('div');
            element.id = target;
            document.body.appendChild(element);
        }
        
        setPortalElement(element);

        // Cleanup function
        return () => {
            // No eliminamos el elemento porque puede ser usado por otros portales
        };
    }, [target]);

    // Si no tenemos el elemento portal aún, no renderizar nada
    if (!portalElement) {
        return null;
    }

    // Usar ReactDOM.createPortal para renderizar fuera del árbol de componentes
    return ReactDOM.createPortal(children, portalElement);
};

export default Portal;